module.exports = __webpack_public_path__ + "img/avatar7.f335959f.png";